import { ReactElement } from 'react';
import { ErrorGoToHomepage } from '../Pages/ui/ErrorLoadingPage';

const Error = (): ReactElement => <ErrorGoToHomepage />;

export default Error;
